// 导入自己需要的组件
import { Button,Drawer,Loading,DatePicker } from 'element-ui'
const element = {
    install: function (Vue) {

        Vue.use(Button)
        Vue.use(Drawer)
        Vue.use(Loading)
        Vue.use(DatePicker)

    }
}
export default element
